import type { BlogPost } from '../types'

export const JESTESMY_ONLINE: BlogPost = {
  slug: 'jestesmy-online',
  lang: 'pl',
  topicId: 'wir-sind-live',
  title: 'Roofora już działa – porównuj oferty solarne',
  metaDescription:
    'Roofora działa już teraz: rynek, na którym firmy rzemieślnicze konkurują o Twoje zlecenie ' +
    'instalacji solarnej - bez lawiny telefonów.',
  keywords: [
    'Roofora start',
    'porównanie ofert fotowoltaicznych bez telefonów',
    'rynek fotowoltaiki start',
    'oferty solarne bez zimnej sprzedaży',
    'zbieranie ofert PV bez lawiny telefonów',
  ],
  publishedAt: '2026-07-11',
  excerpt:
    'Historia jest prosta: sam kiedyś zapytałem o ofertę na instalację solarną i zostałem ' +
    'zasypany telefonami niemal od każdej firmy. Tak mnie to zdenerwowało, że pomyślałem: da się ' +
    'to zrobić lepiej. Więc zbudowałem to sam - i teraz Roofora działa.',
  sections: [
    {
      type: 'paragraph',
      text:
        'Historia jest prosta: sam kiedyś zapytałem o ofertę na instalację solarną i zostałem ' +
        'zasypany telefonami i mailami niemal od każdej firmy - tysiące połączeń, zawyżone ceny, ' +
        'zimna sprzedaż bez końca. Tak mnie to zdenerwowało, że pomyślałem: da się to zrobić lepiej. ' +
        'Więc zbudowałem to sam.',
    },
    {
      type: 'paragraph',
      text:
        'Efektem jest Roofora - i od dziś platforma działa. Koniec z samym konceptem, koniec z ' +
        'zapowiedziami "wkrótce beta" - już teraz możesz złożyć zapytanie i otrzymać prawdziwe ' +
        'oferty od firm rzemieślniczych, bez konieczności wyłączania potem telefonu.',
    },
    {
      type: 'heading',
      text: 'Co szwankuje w klasycznych portalach porównawczych',
    },
    {
      type: 'paragraph',
      text:
        'Ten schemat zna niemal każdy: składasz zapytanie, podajesz swój numer telefonu i adres ' +
        'e-mail - i ten sam lead trafia od razu do kilku firm jednocześnie. Efektem jest lawina ' +
        'telefonów, po której w końcu nie wiadomo już, który dzwoniący odpowiada za którą ofertę. ' +
        'Dokładnie ten podstawowy problem chcieliśmy w Roofora nie tylko złagodzić, ale strukturalnie ' +
        'wyeliminować.',
    },
    {
      type: 'heading',
      text: 'Jak działa Roofora',
    },
    {
      type: 'list',
      items: [
        'Złóż zapytanie: zdjęcia dachu, zdjęcie rozdzielnicy, orientacja dachu i roczne zużycie energii - odpowiednia wielkość instalacji jest wyliczana automatycznie',
        'Anonimowa publikacja: firmy rzemieślnicze widzą Twoje zapytanie, ale nie Twoje dane kontaktowe',
        'Firmy niezależnie od siebie składają niewiążące oferty w stałej cenie - bez Twojego udziału',
        'Spokojnie porównujesz oferty posortowane według ceny',
        'Kontakt nawiązywany jest tylko wtedy, gdy aktywnie zgodzisz się na jedną, konkretną firmę - bez zbiorowej zgody dla wszystkich',
        'Konto zakładasz tylko z nazwą użytkownika i hasłem - e-mail ani numer telefonu nie są do rejestracji potrzebne',
      ],
    },
    {
      type: 'paragraph',
      text:
        'Do tego darmowy kalkulator PV bez rejestracji, dzięki któremu w kilka minut otrzymasz ' +
        'wstępną ocenę wielkości instalacji i uzysku energii z Twojego dachu - wraz z eksportem ' +
        'analizy do PDF.',
    },
    {
      type: 'heading',
      text: 'Dla firm rzemieślniczych',
    },
    {
      type: 'paragraph',
      text:
        'Instalatorzy solarni i firmy elektroinstalacyjne widzą anonimowe zapytania ze swojego ' +
        'regionu - wraz z danymi dachu, zużyciem energii i aktualnie najniższą ofertą, ale bez ' +
        'danych kontaktowych. Złożenie oferty jest bezpłatne i niewiążące. Jeśli firma chce ' +
        'nawiązać kontakt z klientem, wysyła równie bezpłatne zapytanie o kontakt i czeka na ' +
        'indywidualną zgodę dokładnie tego klienta.',
    },
    {
      type: 'heading',
      text: 'Szczerze mówiąc: na razie projekt hobbystyczny, całkowicie bezpłatny',
    },
    {
      type: 'paragraph',
      text:
        'Roofora to obecnie prywatny projekt hobbystyczny w fazie beta - całkowicie bezpłatny ' +
        'zarówno dla klientów, jak i firm rzemieślniczych. Żadnego ukrytego modelu płatności, ' +
        'żadnej karty kredytowej, żadnej pułapki subskrypcyjnej. Gdyby miało się to kiedyś zmienić, ' +
        'poinformujemy o tym jasno i wprost - do tego czasu obowiązuje zasada: wypróbowanie nic nie kosztuje.',
    },
    {
      type: 'paragraph',
      text:
        'Jeśli planujesz instalację solarną i nie masz ochoty na lawinę telefonów, wypróbuj ' +
        'Roofora - zapytanie składasz w kilka minut, a Ty przez cały czas decydujesz, kto może się ' +
        'z Tobą skontaktować.',
    },
  ],
  relatedLinks: [
    { label: 'Jak działa porównanie ofert', href: '/porownaj-oferty-fotowoltaiczne' },
    { label: 'Ile kosztuje instalacja fotowoltaiczna?', href: '/koszt-instalacji-fotowoltaicznej' },
  ],
}
